import { createContext } from "react";

const CurrentUserContext = createContext({
  currentUser: null,
  notification: null,
  login: (user) => {},
  logout: () => {},
  updateCurrentUser: (updates) => {},
  dismissNotification: () => {},
});

export default CurrentUserContext;
